import { makeStyles, tokens } from "@fluentui/react-components";

export const useSearchSectionStyles = makeStyles({
  searchContainer: {
    padding: "5% 12px 0",
    display: "flex",
    flexDirection: "column",
    rowGap: "34px",
    justifyItems: "center",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    flexGrow: 1,
    minWidth: "50%",
  },
  hideSearchContainer: {
    display: "none",
  },
  title: {
    color: tokens.colorNeutralForeground2,
    fontWeight: tokens.fontWeightRegular,
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    columnGap: "17px",
    rowGap: "17px",
    flexWrap: "wrap",
    justifyItems: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  action: {
    minWidth: "142px",
  },
});
